import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 이미지_전체_보기_라우터 = {
  루트: {
    path: '/upload/:taskID/view-image/:taskItemID',
    async lazy() {
      const { default: Page } = await import('@/router/task/이미지_전체_보기/index');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '이미지 전체 보기',
    },
  } satisfies LookoRouteObject,
};

export const 이미지_전체_보기_루트: LookoRouteObject = {
  path: '/',
  element: <Outlet />,
  children: values(이미지_전체_보기_라우터),
};
